import { render, staticRenderFns } from "./PostContentMetadata.vue?vue&type=template&id=2f58e2da"
import script from "./PostContentMetadata.vue?vue&type=script&lang=js"
export * from "./PostContentMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports